import styled from "styled-components";

export const Wrapper = styled("div")(({ theme }) => ({
  backgroundColor: theme.palette.background.page,
  flexGrow: 1,
}));

export const Block = styled("div")(({ theme }) => ({
  ...theme.mixins.flexJustifyBetween,
  alignItems: "flex-start",
  gap: 30,
  padding: "20px 0",

  [theme.down("lg")]: {
    flexDirection: "column",
    gap: 20,
  },
}));

export const LoadingBlock = styled("div")(({ theme }) => ({
  ...theme.mixins.flexCenterCenter,
  width: "100%",
  minHeight: 500,
  backgroundColor: theme.palette.background.page,
}));

export const ErrorBlock = styled("div")(({ theme }) => ({
  ...theme.mixins.flexCenterCenter,
  flexDirection: "column",
  width: "100%",
  minHeight: 500,
  backgroundColor: theme.palette.background.page,
}));

export const SessionBlock = styled("div")(({ theme }) => ({
  fontSize: 12,
  color: theme.palette.text.muted,
  marginTop: 5,
}));

export const ModalBlock = styled("div")(({ theme }) => ({
  width: "100%",
  maxWidth: 500,
  height: "auto",
  padding: 20,

  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  textAlign: "center",
  gap: 20,

  "&>button": {
    width: "100%",
    maxWidth: 200,
    padding: "10px 20px",
    color: theme.palette.text.white,

    border: "none",
    borderRadius: 8,

    backgroundColor: theme.palette.button.primary,
    cursor: "pointer",
    fontSize: 16,
    fontWeight: 600,
    transition: "background-color 0.3s ease",

    "&:hover": {
      backgroundColor: theme.palette.button.primaryHover,
    },
  },
}));
